import { Box, ButtonBase, InputBase, useTheme } from "@mui/material";
import { useState, useRef } from "react";

import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import CloseIcon from '@mui/icons-material/Close';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useTranslation } from "react-i18next";
import { pickingprocesstype } from "../../../../../utils/staticEnums";
import { toast } from "react-toastify";
import { useGetOptionsQuery } from "../../../../../newapi/pickingjob/pickingjobSlice";
import { useGetUsersSelectQuery } from "../../../../../newapi/user/userSlice";
import { useFindPickupCartSelectQuery } from "../../../../../newapi/warehouse/pickupCartSlice";
import { useGetProductsSelectQuery } from "../../../../../newapi/warehouse/productSlice";
import { useGetWarehousesSelectQuery } from "../../../../../newapi/warehouse/warehouseApiSlice";
import { tokens } from "../../../../../theme";
import ButtonGroup from "../../../../theme/buttons/ButtonGroup";
import Shbutton from "../../../../theme/buttons/Shbutton";
import { ShDropdownQuery, ShDropdownSearchQuery } from "../../../../theme/dropdowns/Dropdown";
import ShTextSkeleton from "../../../../theme/skeleton/ShTextSkeleton";
import Heading from "../../../../theme/text/Heading";
import Subheading from "../../../../theme/text/Subheading";
import Text from "../../../../theme/text/Text";
import { CountShQueryDropdown } from "../components/CountShQueryDropdown";
import { CartDropdownComponent } from "../components/CartDropdownComponent";
import { ProductOpenSinglesItem } from "../components/ProductOpenSinglesItem";
import { ProductOpenSinglesPreview } from "../components/ProductOpenSinglesPreview";


export const StartCreatebatchTitle = ({optionMap, setOptionMap,userError,warehouseError}) => {
    const {t} = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    return (
        <>
        
            <Heading>{t("create_batch")}</Heading>
            <Box
                sx={{
                    display:'flex',
                    width:1,
                    mt:2,
                }}
            >
                <Box
                    sx={{
                        flex:1,
                        display:'flex',
                        flexDirection:'column',
                        gap:1,
                        mr:4.5,
                    }}
                >
                    <ShDropdownQuery
                        name="name"
                        onChange={(selected,object) => {
                            setOptionMap(optionMap => ({
                                ...optionMap,
                                user: selected !== null ? object : {
                                    id:-1,
                                    name: t("no_selection")
                                }
                            }))
                        }}
                        valueKey={"id"}
                        dataKey={null}
                        shComponent={<CountShQueryDropdown/>}
                        selected={optionMap.user.id}
                        content={useGetUsersSelectQuery}
                        closeOnSelection
                    >
                        {({anchorEl,onClick}) => (
                            <ButtonBase
                                onClick={onClick}
                                sx={{
                                    height:32,
                                    borderRadius:5,
                                    background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0],
                                    border:`1px solid ${userError ? colors.red[400] : theme.palette.mode === "dark" ? colors.blue[400] : colors.primary[400]}`,
                                    display:"flex",
                                    alignItems:'center',
                                    px:0.5,
                                    position:'relative',
                                    "&:before" : {
                                        content:'""',
                                        position:'absolute',
                                        borderRadius:5,
                                        left:0,
                                        top:0,
                                        width:1,
                                        height:1,
                                        background:userError ? colors.red[100] : theme.palette.mode === "dark" ? colors.blue[100] : colors.primary[100],
                                        // border:`1px solid ${colors.grey[100]}`,
                                        boxShadow:`0px 2px 4px ${colors.grey[200]}`,
                                    }
                                }}
                            >

                                <Box
                                    sx={{
                                        height:24,
                                        lineHeight:"24px",
                                        background:userError ? colors.red[400] :  theme.palette.mode === "dark" ? colors.blue[400] :  colors.primary[400],
                                        borderRadius:3,
                                        border: `1px solid ${userError ? colors.red[400] :  theme.palette.mode === "dark" ? colors.blue[400] :  colors.primary[400]}`,
                                        width:110,
                                        textAlign:"center",
                                        fontSize:14,
                                        fontWeight:"bold",
                                        color:theme.palette.mode === "dark" ? colors.txt["primaryDark"] : colors.txt["light"],
                                    }}
                                >
                                    {t("user")}

                                </Box>
                                <Box
                                    sx={{
                                        flex:1,
                                        ml:1.5,
                                        textAlign:"left",
                                    }}
                                >
                                    <Text bold >
                                        {optionMap.user?.name}
                                    </Text>
                                </Box>
                                <Box
                                    sx={{
                                        display:'flex',
                                        gap:1.5,
                                        alignItems:'center',
                                    }}
                                >
                                    <Text italic bold variant={userError ? "red" : theme.palette.mode === "dark" ? "blue" :  "primary"}>
                                        {t("required")}
                                    </Text>
                                    <Box
                                        sx={{
                                            height:24,
                                            width:24,
                                            borderRadius:3,
                                            display:"flex",
                                            alignItems:'center',
                                            justifyContent:"center",
                                            background:userError ? colors.red[100] :  theme.palette.mode === "dark" ? colors.blue[100] :  colors.primary[100],
                                            border: `1px solid ${userError ? colors.red[400] :  theme.palette.mode === "dark" ? colors.blue[400] :  colors.primary[400]}`,
                                            color: userError ? colors.red[400] :  theme.palette.mode === "dark" ? colors.blue[400] :  colors.primary[400],
                                        }}
                                    >
                                        <KeyboardArrowDownIcon/>

                                    </Box>
                                </Box>

                            </ButtonBase>
                        )}
                    </ShDropdownQuery>

                    <ShDropdownQuery
                        onChange={(selected,object) => {
                            setOptionMap(optionMap => ({
                                ...optionMap,
                                warehouse: selected !== null ? object : {
                                    id:-1,
                                    name: t("no_selection")
                                }
                            }))
                        }}
                        valueKey={"id"}
                        dataKey={"data"}
                        shComponent={<CountShQueryDropdown/>}
                        selected={optionMap.warehouse.id}
                        content={useGetWarehousesSelectQuery}
                        closeOnSelection
                    >
                        {({anchorEl,onClick}) => (
                            <ButtonBase
                                onClick={onClick}
                                sx={{
                                    height:32,
                                    borderRadius:5,
                                    background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0],
                                    border:`1px solid ${warehouseError ? colors.red[400] : theme.palette.mode === "dark" ? colors.blue[400] : colors.primary[400]}`,
                                    display:"flex",
                                    alignItems:'center',
                                    px:0.5,
                                    position:'relative',
                                    "&:before" : {
                                        content:'""',
                                        position:'absolute',
                                        borderRadius:5,
                                        left:0,
                                        top:0,
                                        width:1,
                                        height:1,
                                        background:warehouseError ? colors.red[100] : theme.palette.mode === "dark" ? colors.blue[100] : colors.primary[100],
                                        // border:`1px solid ${colors.grey[100]}`,
                                        boxShadow:`0px 2px 4px ${colors.grey[200]}`,
                                    }
                                }}
                            >

                                <Box
                                    sx={{
                                        height:24,
                                        lineHeight:"24px",
                                        background:warehouseError ? colors.red[400] :  theme.palette.mode === "dark" ? colors.blue[400] :  colors.primary[400],
                                        borderRadius:3,
                                        border: `1px solid ${warehouseError ? colors.red[400] :  theme.palette.mode === "dark" ? colors.blue[400] :  colors.primary[400]}`,
                                        width:110,
                                        textAlign:"center",
                                        fontSize:14,
                                        fontWeight:"bold",
                                        color:theme.palette.mode === "dark" ? colors.txt["primaryDark"] : colors.txt["light"],
                                    }}
                                >
                                    {t("warehouse")}

                                </Box>
                                <Box
                                    sx={{
                                        flex:1,
                                        ml:1.5,
                                        textAlign:"left",
                                    }}
                                >
                                    <Text bold >
                                        {optionMap.warehouse?.name}
                                    </Text>
                                </Box>
                                <Box
                                    sx={{
                                        display:'flex',
                                        gap:1.5,
                                        alignItems:'center',
                                    }}
                                >
                                    <Text italic bold variant={warehouseError ? "red" : theme.palette.mode === "dark" ? "blue" :  "primary"}>
                                        {t("required")}
                                    </Text>
                                    <Box
                                        sx={{
                                            height:24,
                                            width:24,
                                            borderRadius:3,
                                            display:"flex",
                                            alignItems:'center',
                                            justifyContent:"center",
                                            background:warehouseError ? colors.red[100] :  theme.palette.mode === "dark" ? colors.blue[100] :  colors.primary[100],
                                            border: `1px solid ${warehouseError ? colors.red[400] :  theme.palette.mode === "dark" ? colors.blue[400] :  colors.primary[400]}`,
                                            color: warehouseError ? colors.red[400] :  theme.palette.mode === "dark" ? colors.blue[400] :  colors.primary[400],
                                        }}
                                    >
                                        <KeyboardArrowDownIcon/>

                                    </Box>
                                </Box>

                            </ButtonBase>
                        )}
                    </ShDropdownQuery>
                </Box>
                <Box 
                    sx={{
                        flex:1,
                    }}
                />
            </Box>
        </>
    )
}

export const StartCreatebatchBody = ({getFilterIds, optionMap, setOptionMap,cartError,streamError,amountError, pickingCratesError, getProducts,isLoading, isFetching, filterCount, setOrderAmount,orderAmount,getWarehouseZones}) => {
    const {t} = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [crateInput, setCrateInput] = useState("");
    const crateInputRef = useRef(null);

    const handleAddCrate = () => {
        const trimmed = crateInput.trim();
        if (trimmed.length > 0 && !optionMap.pickingCrates.includes(trimmed)) {
            setOptionMap(prev => ({
                ...prev,
                pickingCrates: [...prev.pickingCrates, trimmed]
            }));
        }
        setCrateInput("");
        crateInputRef.current?.focus();
    };

    const handleRemoveCrate = (barcode) => {
        setOptionMap(prev => ({
            ...prev,
            pickingCrates: prev.pickingCrates.filter(c => c !== barcode)
        }));
        crateInputRef.current?.focus();
    };

    const handleCrateKeyDown = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            handleAddCrate();
        }
    };

    return (
        <Box
            sx={{
                // flex:1,
                display:"flex",
            }}
        >
            <Box
                sx={{
                    flex:1,
                    pl:3,
                    pt:3,
                    pr:1.5,
                }}
            >
                <Box
                    sx={{
                        p:2,
                        display:"flex",
                        flexDirection:"column",
                        background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                        border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                        boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                        borderRadius:4,
                    }}
                >
                    <Text bold>{t('general')}</Text>

                    <ShDropdownQuery
                        onChange={(selected,object) => {
                            setOptionMap(optionMap => ({
                                ...optionMap,
                                stream: selected !== null ? object : {
                                    id:-1,
                                    name: t("no_selection")
                                }
                            }))
                        }}
                        valueKey={"id"}
                        dataKey={"data.streams"}
                        shComponent={<CountShQueryDropdown/>}
                        selected={optionMap.stream.id}
                        config={{
                            type:"stream",
                            body: getFilterIds(optionMap),
                        }}
                        content={useGetOptionsQuery}
                        closeOnSelection
                        lazyLoad
                        searchOptions={{
                            enabled:true,
                            placeholder:t("search")
                        }}
                    >
                        {({anchorEl,onClick}) => (
                            <ButtonBase
                                disabled={optionMap.warehouse.id === -1}
                                onClick={(e) => {
                                    if(optionMap.warehouse.id > -1 && optionMap.user.id > -1 ) {
                                        onClick(e);
                                    }
                                }}
                                sx={{
                                    mt:1,
                                    height:32,
                                    borderRadius:5,
                                    background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0],
                                    border:`1px solid ${streamError ? colors.red[400] : theme.palette.mode === "dark" ? colors.blue[400] : colors.primary[400]}`,
                                    display:"flex",
                                    alignItems:'center',
                                    px:0.5,
                                    position:'relative',
                                    opacity: optionMap.warehouse.id > -1 && optionMap.user.id > -1  ? 1 : 0.35,
                                    "&:before" : {
                                        content:'""',
                                        position:'absolute',
                                        borderRadius:5,
                                        left:0,
                                        top:0,
                                        width:1,
                                        height:1,
                                        background:streamError ? colors.red[100] : theme.palette.mode === "dark" ? colors.blue[100] : colors.primary[100],
                                        // border:`1px solid ${colors.grey[100]}`,
                                        boxShadow:`0px 2px 4px ${colors.grey[200]}`,
                                    }
                                }}
                            >

                                <Box
                                    sx={{
                                        height:24,
                                        lineHeight:"24px",
                                        background:streamError ? colors.red[400] :  theme.palette.mode === "dark" ? colors.blue[400] :  colors.primary[400],
                                        borderRadius:3,
                                        border: `1px solid ${streamError ? colors.red[400] :  theme.palette.mode === "dark" ? colors.blue[400] :  colors.primary[400]}`,
                                        width:110,
                                        textAlign:"center",
                                        fontSize:14,
                                        fontWeight:"bold",
                                        color:theme.palette.mode === "dark" ? colors.txt["primaryDark"] : colors.txt["light"],
                                    }}
                                >
                                    {t("stream")}

                                </Box>
                                <Box
                                    sx={{
                                        flex:1,
                                        ml:1.5,
                                        textAlign:"left",
                                    }}
                                >
                                    <Text bold >
                                        {optionMap.stream?.name}
                                    </Text>
                                </Box>
                                <Box
                                    sx={{
                                        display:'flex',
                                        gap:1.5,
                                        alignItems:'center',
                                    }}
                                >
                                    <Text italic bold variant={streamError ? "red" : theme.palette.mode === "dark" ? "blue" :  "primary"}>
                                        {t("required")}
                                    </Text>
                                    <Box
                                        sx={{
                                            height:24,
                                            width:24,
                                            borderRadius:3,
                                            display:"flex",
                                            alignItems:'center',
                                            justifyContent:"center",
                                            background:streamError ? colors.red[100] :  theme.palette.mode === "dark" ? colors.blue[100] :  colors.primary[100],
                                            border: `1px solid ${streamError ? colors.red[400] :  theme.palette.mode === "dark" ? colors.blue[400] :  colors.primary[400]}`,
                                            color: streamError ? colors.red[400] :  theme.palette.mode === "dark" ? colors.blue[400] :  colors.primary[400],
                                        }}
                                    >
                                        <KeyboardArrowDownIcon/>

                                    </Box>
                                </Box>

                            </ButtonBase>
                        )}
                    </ShDropdownQuery>

                    {optionMap.stream?.cartScan && (

                        <ShDropdownQuery
                            onChange={(selected,object) => {
                                setOptionMap(optionMap => ({
                                    ...optionMap,
                                    cart: selected !== null ? object : {
                                        id:-1,
                                        barcode: t("no_selection")
                                    }
                                }))
                            }}
                            valueKey={"id"}
                            displayName={"barcode"}
                            shComponent={<CartDropdownComponent/>}
                            selected={optionMap.cart.id}
                            dataKey={"data"}
                            content={useFindPickupCartSelectQuery}
                            closeOnSelection
                            searchOptions={{
                                enabled:true,
                                placeholder:t("search")
                            }}
                        >
                            {({anchorEl,onClick}) => (
                                <ButtonBase
                                    disabled={optionMap.warehouse.id === -1}
                                    onClick={(e) => {
                                        if(optionMap.warehouse.id > -1 && optionMap.user.id > -1 ) {
                                            onClick(e);
                                        }
                                    }}
                                    sx={{
                                        mt:1,
                                        height:32,
                                        borderRadius:5,
                                        background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0],
                                        border:`1px solid ${cartError ? colors.red[400] : theme.palette.mode === "dark" ? colors.blue[400] : colors.primary[400]}`,
                                        display:"flex",
                                        alignItems:'center',
                                        px:0.5,
                                        position:'relative',
                                        opacity: optionMap.warehouse.id > -1 && optionMap.user.id > -1  ? 1 : 0.35,
                                        "&:before" : {
                                            content:'""',
                                            position:'absolute',
                                            borderRadius:5,
                                            left:0,
                                            top:0,
                                            width:1,
                                            height:1,
                                            background:cartError ? colors.red[100] : theme.palette.mode === "dark" ? colors.blue[100] : colors.primary[100],
                                            // border:`1px solid ${colors.grey[100]}`,
                                            boxShadow:`0px 2px 4px ${colors.grey[200]}`,
                                        }
                                    }}
                                >

                                    <Box
                                        sx={{
                                            height:24,
                                            lineHeight:"24px",
                                            background:cartError ? colors.red[400] :  theme.palette.mode === "dark" ? colors.blue[400] :  colors.primary[400],
                                            borderRadius:3,
                                            border: `1px solid ${cartError ? colors.red[400] :  theme.palette.mode === "dark" ? colors.blue[400] :  colors.primary[400]}`,
                                            width:110,
                                            textAlign:"center",
                                            fontSize:14,
                                            fontWeight:"bold",
                                            color:theme.palette.mode === "dark" ? colors.txt["primaryDark"] : colors.txt["light"],
                                        }}
                                    >
                                        {t("pickupcart")}

                                    </Box>
                                    <Box
                                        sx={{
                                            flex:1,
                                            ml:1.5,
                                            textAlign:"left",
                                        }}
                                    >
                                        <Text bold >
                                            {optionMap.cart?.barcode}
                                        </Text>
                                    </Box>
                                    <Box
                                        sx={{
                                            display:'flex',
                                            gap:1.5,
                                            alignItems:'center',
                                        }}
                                    >
                                        <Text italic bold variant={cartError ? "red" : theme.palette.mode === "dark" ? "blue" :  "primary"}>
                                            {t("required")}
                                        </Text>
                                        <Box
                                            sx={{
                                                height:24,
                                                width:24,
                                                borderRadius:3,
                                                display:"flex",
                                                alignItems:'center',
                                                justifyContent:"center",
                                                background:cartError ? colors.red[100] :  theme.palette.mode === "dark" ? colors.blue[100] :  colors.primary[100],
                                                border: `1px solid ${cartError ? colors.red[400] :  theme.palette.mode === "dark" ? colors.blue[400] :  colors.primary[400]}`,
                                                color: cartError ? colors.red[400] :  theme.palette.mode === "dark" ? colors.blue[400] :  colors.primary[400],
                                            }}
                                        >
                                            <KeyboardArrowDownIcon/>

                                        </Box>
                                    </Box>

                                </ButtonBase>
                            )}
                        </ShDropdownQuery>
                    )}
                    {optionMap.stream?.pickingprocesstype === pickingprocesstype.CART_CRATE && (
                        <Box
                            sx={{
                                mt:1,
                                display:"flex",
                                flexDirection:"column",
                                gap:1,
                                mb:2,
                            }}
                        >
                            <Box
                                sx={{
                                    height:32,
                                    borderRadius:5,
                                    background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0],
                                    border:`1px solid ${pickingCratesError ? colors.red[400] : theme.palette.mode === "dark" ? colors.blue[400] : colors.primary[400]}`,
                                    display:"flex",
                                    alignItems:'center',
                                    px:0.5,
                                    position:'relative',
                                    "&:before" : {
                                        content:'""',
                                        position:'absolute',
                                        borderRadius:5,
                                        left:0,
                                        top:0,
                                        width:1,
                                        height:1,
                                        background:pickingCratesError ? colors.red[100] : theme.palette.mode === "dark" ? colors.blue[100] : colors.primary[100],
                                        boxShadow:`0px 2px 4px ${colors.grey[200]}`,
                                    }
                                }}
                            >
                                <Box
                                    sx={{
                                        height:24,
                                        lineHeight:"24px",
                                        background:pickingCratesError ? colors.red[400] :  theme.palette.mode === "dark" ? colors.blue[400] :  colors.primary[400],
                                        borderRadius:3,
                                        border: `1px solid ${pickingCratesError ? colors.red[400] :  theme.palette.mode === "dark" ? colors.blue[400] :  colors.primary[400]}`,
                                        width:110,
                                        textAlign:"center",
                                        fontSize:14,
                                        fontWeight:"bold",
                                        color:theme.palette.mode === "dark" ? colors.txt["primaryDark"] : colors.txt["light"],
                                        flexShrink:0,
                                    }}
                                >
                                    {t("crate")}
                                </Box>
                                <InputBase
                                    inputRef={crateInputRef}
                                    value={crateInput}
                                    onChange={(e) => setCrateInput(e.target.value)}
                                    onKeyDown={handleCrateKeyDown}
                                    placeholder={t("scan_crate_barcode")}
                                    autoFocus
                                    sx={{
                                        flex:1,
                                        ml:1.5,
                                        fontSize:14,
                                        fontWeight:500,
                                        color:colors.txt["primary"],
                                        "& input::placeholder": {
                                            opacity:0.6,
                                        }
                                    }}
                                />
                                <Box
                                    sx={{
                                        display:'flex',
                                        gap:1.5,
                                        alignItems:'center',
                                    }}
                                >
                                    <Text italic bold variant={pickingCratesError ? "red" : theme.palette.mode === "dark" ? "blue" :  "primary"}>
                                        {t("required")}
                                    </Text>
                                    <Box
                                        sx={{
                                            height:24,
                                            minWidth:24,
                                            px:1,
                                            borderRadius:3,
                                            display:"flex",
                                            alignItems:'center',
                                            justifyContent:"center",
                                            background:pickingCratesError ? colors.red[100] :  theme.palette.mode === "dark" ? colors.blue[100] :  colors.primary[100],
                                            border: `1px solid ${pickingCratesError ? colors.red[400] :  theme.palette.mode === "dark" ? colors.blue[400] :  colors.primary[400]}`,
                                            color: pickingCratesError ? colors.red[400] :  theme.palette.mode === "dark" ? colors.blue[400] :  colors.primary[400],
                                            fontSize:12,
                                            fontWeight:600,
                                        }}
                                    >
                                        {optionMap.pickingCrates.length}
                                    </Box>
                                </Box>
                            </Box>

                            {optionMap.pickingCrates.length > 0 && (
                                <Box
                                    sx={{
                                        display:"flex",
                                        flexWrap:"wrap",
                                        gap:0.5,
                                    }}
                                >
                                    {optionMap.pickingCrates.map((barcode) => (
                                        <Box
                                            key={barcode}
                                            sx={{
                                                height:24,
                                                borderRadius:3,
                                                background:theme.palette.mode === "dark" ? colors.grey[500] : colors.grey[100],
                                                display:"flex",
                                                alignItems:'center',
                                                gap:0.5,
                                                pl:1,
                                                pr:0.5,
                                            }}
                                        >
                                            <Text fontSize={12} semibold>
                                                {barcode}
                                            </Text>
                                            <ButtonBase
                                                onClick={() => handleRemoveCrate(barcode)}
                                                sx={{
                                                    height:18,
                                                    width:18,
                                                    borderRadius:2,
                                                    display:"flex",
                                                    alignItems:'center',
                                                    justifyContent:"center",
                                                    color:colors.red[400],
                                                    "&:hover": {
                                                        background:colors.red[100],
                                                    }
                                                }}
                                            >
                                                <CloseIcon sx={{ fontSize:14 }} />
                                            </ButtonBase>
                                        </Box>
                                    ))}
                                </Box>
                            )}
                        </Box>
                    )}

                    <ShDropdownQuery
                        onChange={(selected,object) => {
                            setOptionMap(optionMap => ({
                                ...optionMap,
                                relation: selected !== null ? object : {
                                    id:-1,
                                    name: t("all")
                                }
                            }))
                        }}
                        valueKey={"id"}
                        dataKey={"data.relations"}
                        shComponent={<CountShQueryDropdown/>}
                        selected={optionMap.relation.id}
                        config={{
                            type:"relation",
                            body: getFilterIds(optionMap),
                        }}
                        content={useGetOptionsQuery}
                        closeOnSelection
                        lazyLoad
                        searchOptions={{
                            enabled:true,
                            placeholder:t("search")
                        }}
                    >
                        {({anchorEl,onClick}) => (
                            <ButtonBase

                                disabled={optionMap.warehouse.id === -1}
                                onClick={(e) => {
                                    if(optionMap.warehouse.id > -1 && optionMap.user.id > -1 ) {
                                        onClick(e);
                                    }
                                }}
                                sx={{
                                    mt:1.5,
                                    height:32,
                                    borderRadius:5,
                                    background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[0],
                                    boxShadow:`0px 2px 4px ${colors.grey[200]}`,
                                    border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                                    display:"flex",
                                    alignItems:'center',
                                    px:0.5,
                                    opacity: optionMap.warehouse.id > -1 && optionMap.user.id > -1  ? 1 : 0.35
                                }}
                            >

                                <Box
                                    sx={{
                                        height:24,
                                        lineHeight:"24px",
                                        background:theme.palette.mode === "dark" ? colors.grey[600] : colors.grey[100],
                                        borderRadius:3,
                                        width:110,
                                        textAlign:"center",
                                        fontSize:14,
                                        color:theme.palette.mode === "dark" ? colors.txt["softened"] : colors.txt["primary"],
                                    }}
                                >
                                    {t("relation")}

                                </Box>
                                <Box
                                    sx={{
                                        flex:1,
                                        ml:1.5,
                                        textAlign:"left",
                                    }}
                                >
                                    <Text semibold >
                                        {optionMap.relation.name}
                                    </Text>
                                </Box>
                                <Box
                                    sx={{
                                        display:'flex',
                                        gap:1.5,
                                        alignItems:'center',
                                    }}
                                >
                                    <Text italic>
                                        {t("optional")}
                                    </Text>
                                    <Box
                                        sx={{
                                            height:24,
                                            width:24,
                                            borderRadius:3,
                                            display:"flex",
                                            alignItems:'center',
                                            justifyContent:"center",
                                            background:theme.palette.mode === "dark" ? colors.grey[600] : colors.grey[100],
                                            color: colors.txt["secondary"],
                                        }}
                                    >
                                        <KeyboardArrowDownIcon/>

                                    </Box>
                                </Box>

                            </ButtonBase>
                        )}
                    </ShDropdownQuery> 

                    <ShDropdownSearchQuery
                        maxWidth={350}
                        onChange={(selected,object) => {
                            setOptionMap(optionMap => {
                                const updatedProduct = optionMap.product.filter(zone =>
                                    selected.includes(zone.id) // Keep only the zones whose ids are in selected
                                );

                                // If the object is in the selected list, add it to the warehousezone
                                if (selected.includes(object.id)) {
                                    updatedProduct.push(object);
                                }

                                // Return the updated optionMap with the modified warehousezone
                                return {
                                    ...optionMap,
                                    product: updatedProduct,
                                };
                            });

                        }}
                        // valueKey={"id"}
                        // dataKey={"data.relations"}
                        // shComponent={<CountShQueryDropdown/>}
                        selected={getProducts()}
                        multiple={true}
                        displayName={"combined"}
                        content={useGetProductsSelectQuery}
                        config={{
                            ...getFilterIds(optionMap),
                            openSingles: true,
                            ...(optionMap.relation.id > -1 ? { relationId: optionMap.relation.id } : {}),
                        }}
                        shComponent={<ProductOpenSinglesItem/>}
                        extraComponent={
                            <ProductOpenSinglesPreview
                                filterBody={getFilterIds(optionMap)}
                                product={optionMap.product}
                                setOptionMap={setOptionMap}
                            />
                        }
                        searchOptions={{
                            placeholder:t("search")
                        }}
                        closeOnSelection
                    >
                        {({anchorEl,onClick}) => (
                            <ButtonBase
                                
                                disabled={optionMap.warehouse.id === -1}
                                onClick={(e) => {
                                    if(optionMap.warehouse.id > -1 && optionMap.user.id > -1 ) {
                                        onClick(e);
                                    }
                                }}
                                sx={{
                                    mt:1.5,
                                    height:32,
                                    borderRadius:5,
                                    background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[0],
                                    boxShadow:`0px 2px 4px ${colors.grey[200]}`,
                                    border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                                    display:"flex",
                                    alignItems:'center',
                                    px:0.5,
                                    opacity: optionMap.warehouse.id > -1 && optionMap.user.id > -1  ? 1 : 0.35
                                }}
                            >

                                <Box
                                    sx={{
                                        height:24,
                                        lineHeight:"24px",
                                        background:theme.palette.mode === "dark" ? colors.grey[600] : colors.grey[100],
                                        borderRadius:3,
                                        width:110,
                                        textAlign:"center",
                                        fontSize:14,
                                        color:theme.palette.mode === "dark" ? colors.txt["softened"] : colors.txt["primary"],
                                    }}
                                >
                                    {t("product")}

                                </Box>
                                <Box
                                    sx={{
                                        flex:1,
                                        ml:1.5,
                                        textAlign:"left",
                                    }}
                                >

                                    {optionMap.product.length === 0 ?
                                        <Text bold>
                                            {t("all")}
                                        </Text>
                                    :
                                        <Box>
                                            <Text bold>
                                                {optionMap.product.length}&nbsp;
                                            </Text>

                                            <Text light>
                                                {t("selected")}
                                            </Text>
                                        </Box>
                                    }
                                </Box>
                                <Box
                                    sx={{
                                        display:'flex',
                                        gap:1.5,
                                        alignItems:'center',
                                    }}
                                >
                                    <Text italic>
                                        {t("optional")}
                                    </Text>
                                    <Box
                                        sx={{
                                            height:24,
                                            width:24,
                                            borderRadius:3,
                                            display:"flex",
                                            alignItems:'center',
                                            justifyContent:"center",
                                            background:theme.palette.mode === "dark" ? colors.grey[600] : colors.grey[100],
                                            color: colors.txt["secondary"],
                                        }}
                                    >
                                        <KeyboardArrowDownIcon/>

                                    </Box>
                                </Box>

                            </ButtonBase>
                        )}
                    </ShDropdownSearchQuery> 
                </Box>

                <Box
                    sx={{
                        mt:2,
                        p:2,
                        display:"flex",
                        flexDirection:"column",
                        background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                        border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                        boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                        borderRadius:4,
                    }}
                >
                    <Text bold>{t('shipper')}</Text>

                    <ShDropdownQuery
                        onChange={(selected,object) => {
                            setOptionMap(optionMap => ({
                                ...optionMap,
                                shipper: selected !== null && selected !== -1 ? object : {
                                    id:-1,
                                    name: t("all")
                                },
                                ...((selected === null || selected === -1) && {
                                    shipperProfile: {
                                        id:-1,
                                        name: t("all")
                                    }
                                })
                            }))
                        }}
                        valueKey={"id"}
                        dataKey={"data.shippers"}
                        shComponent={<CountShQueryDropdown/>}
                        selected={optionMap.shipper.id}
                        config={{
                            type:"shipper",
                            body: getFilterIds(optionMap),
                        }}
                        content={useGetOptionsQuery}
                        closeOnSelection
                        lazyLoad
                    >
                        {({anchorEl,onClick}) => (
                            <ButtonBase

                                disabled={optionMap.warehouse.id === -1}
                                onClick={(e) => {
                                    if(optionMap.warehouse.id > -1 && optionMap.user.id > -1 ) {
                                        onClick(e);
                                    }
                                }}
                                sx={{
                                    mt:1.5,
                                    height:32,
                                    borderRadius:5,
                                    background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[0],
                                    boxShadow:`0px 2px 4px ${colors.grey[200]}`,
                                    border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                                    display:"flex",
                                    alignItems:'center',
                                    px:0.5,
                                    opacity: optionMap.warehouse.id > -1 && optionMap.user.id > -1  ? 1 : 0.35
                                }}
                            >

                                <Box
                                    sx={{
                                        height:24,
                                        lineHeight:"24px",
                                        background:theme.palette.mode === "dark" ? colors.grey[600] : colors.grey[100],
                                        borderRadius:3,
                                        width:110,
                                        textAlign:"center",
                                        fontSize:14,
                                        color:theme.palette.mode === "dark" ? colors.txt["softened"] : colors.txt["primary"],
                                    }}
                                >
                                    {t("shipper")}

                                </Box>
                                <Box
                                    sx={{
                                        flex:1,
                                        ml:1.5,
                                        textAlign:"left",
                                    }}
                                >
                                    <Text semibold >
                                        {optionMap.shipper.name}
                                    </Text>
                                </Box>
                                <Box
                                    sx={{
                                        display:'flex',
                                        gap:1.5,
                                        alignItems:'center',
                                    }}
                                >
                                    <Text italic>
                                        {t("optional")}
                                    </Text>
                                    <Box
                                        sx={{
                                            height:24,
                                            width:24,
                                            borderRadius:3,
                                            display:"flex",
                                            alignItems:'center',
                                            justifyContent:"center",
                                            background:theme.palette.mode === "dark" ? colors.grey[600] : colors.grey[100],
                                            color: colors.txt["secondary"],
                                        }}
                                    >
                                        <KeyboardArrowDownIcon/>

                                    </Box>
                                </Box>

                            </ButtonBase>
                        )}
                    </ShDropdownQuery>

                    <ShDropdownQuery
                        onChange={(selected,object) => {
                            setOptionMap(optionMap => ({
                                ...optionMap,
                                shipperProfile: selected !== null ? object : {
                                    id:-1,
                                    name: t("all")
                                }
                            }))
                        }}
                        valueKey={"id"}
                        dataKey={"data.shipperprofiles"}
                        shComponent={<CountShQueryDropdown/>}
                        selected={optionMap.shipperProfile.id}
                        config={{
                            type:"shipperProfile",
                            body: getFilterIds(optionMap),
                        }}
                        content={useGetOptionsQuery}
                        closeOnSelection
                        lazyLoad
                    >
                        {({anchorEl,onClick}) => (
                            <ButtonBase
                                disabled={optionMap.warehouse.id === -1 || optionMap.shipper.id === -1}
                                onClick={(e) => {
                                    if(optionMap.warehouse.id > -1 && optionMap.user.id > -1 && optionMap.shipper.id > -1) {
                                        onClick(e);
                                    }
                                }}
                                sx={{
                                    mt:1.5,
                                    height:32,
                                    borderRadius:5,
                                    background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[0],
                                    boxShadow:`0px 2px 4px ${colors.grey[200]}`,
                                    border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                                    display:"flex",
                                    alignItems:'center',
                                    px:0.5,
                                    opacity: optionMap.warehouse.id > -1 && optionMap.user.id > -1 && optionMap.shipper.id > -1 ? 1 : 0.35
                                }}
                            >

                                <Box
                                    sx={{
                                        height:24,
                                        lineHeight:"24px",
                                        background:theme.palette.mode === "dark" ? colors.grey[600] : colors.grey[100],
                                        borderRadius:3,
                                        width:110,
                                        textAlign:"center",
                                        fontSize:14,
                                        color:theme.palette.mode === "dark" ? colors.txt["softened"] : colors.txt["primary"],
                                    }}
                                >
                                    {t("shipper_profile")}

                                </Box>
                                <Box
                                    sx={{
                                        flex:1,
                                        ml:1.5,
                                        textAlign:"left",
                                    }}
                                >
                                    <Text semibold >
                                        {optionMap.shipperProfile.name}
                                    </Text>
                                </Box>
                                <Box
                                    sx={{
                                        display:'flex',
                                        gap:1.5,
                                        alignItems:'center',
                                    }}
                                >
                                    <Text italic>
                                        {t("optional")}
                                    </Text>
                                    <Box
                                        sx={{
                                            height:24,
                                            width:24,
                                            borderRadius:3,
                                            display:"flex",
                                            alignItems:'center',
                                            justifyContent:"center",
                                            background:theme.palette.mode === "dark" ? colors.grey[600] : colors.grey[100],
                                            color: colors.txt["secondary"],
                                        }}
                                    >
                                        <KeyboardArrowDownIcon/>

                                    </Box>
                                </Box>

                            </ButtonBase>
                        )}
                    </ShDropdownQuery>
                </Box>

                <Box
                    sx={{
                        mt:2,
                        p:2,
                        display:"flex",
                        flexDirection:"column",
                        background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                        border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                        boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                        borderRadius:4,
                    }}
                >
                    <Text bold>{t('reach')}</Text>

                    <ShDropdownQuery

                        onChange={(selected,object) => {
                            
                            setOptionMap(optionMap => {
                                const updatedWarehousezone = optionMap.warehousezone.filter(zone => 
                                    selected.includes(zone.id) // Keep only the zones whose ids are in selected
                                );

                                // If the object is in the selected list, add it to the warehousezone
                                if (selected.includes(object.id)) {
                                    updatedWarehousezone.push(object);
                                }

                                // Return the updated optionMap with the modified warehousezone
                                return {
                                    ...optionMap,
                                    warehousezone: updatedWarehousezone,
                                };
                            });

                        }}
                        valueKey={"id"}
                        dataKey={"data.warehouseZones"}
                        shComponent={<CountShQueryDropdown/>}
                        multiple
                        selected={getWarehouseZones()}
                        config={{
                            type:"warehousezone",
                            body: getFilterIds(optionMap),
                        }}
                        content={useGetOptionsQuery}
                        lazyLoad
                    >
                        {({anchorEl,onClick}) => (
                            <ButtonBase

                                disabled={optionMap.warehouse.id === -1}
                                onClick={(e) => {
                                    if(optionMap.warehouse.id > -1 && optionMap.user.id > -1 ) {
                                        onClick(e);
                                    }
                                }}
                                sx={{
                                    mt:1.5,
                                    height:32,
                                    borderRadius:5,
                                    background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[0],
                                    boxShadow:`0px 2px 4px ${colors.grey[200]}`,
                                    border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                                    display:"flex",
                                    alignItems:'center',
                                    px:0.5,
                                    opacity: optionMap.warehouse.id > -1 && optionMap.user.id > -1  ? 1 : 0.35
                                }}
                            >

                                <Box
                                    sx={{
                                        height:24,
                                        lineHeight:"24px",
                                        background:theme.palette.mode === "dark" ? colors.grey[600] : colors.grey[100],
                                        borderRadius:3,
                                        width:110,
                                        textAlign:"center",
                                        fontSize:14,
                                        color:theme.palette.mode === "dark" ? colors.txt["softened"] : colors.txt["primary"],
                                    }}
                                >
                                    {t("warehousezone")}

                                </Box>
                                <Box
                                    sx={{
                                        fontFamily:"Roboto,sans-serif",
                                        flex:1,
                                        ml:1.5,
                                        textAlign:"left",
                                        overflow:"hidden",
                                        textOverflow:"ellipsis",
                                        whiteSpace:"nowrap",
                                        mr:2,
                                        color:colors.txt["primary"],
                                        fontWeight:"500",

                                    }}
                                >
                                    {optionMap.warehousezone.length > 0 ?
                                        optionMap.warehousezone.map((zone, index) => (
                                            `${zone.name}${index < optionMap.warehousezone.length - 1 ? ', ' : ''}`
                                        ))
                                    : 
                                        t("all")
                                    }
                                </Box>
                                <Box
                                    sx={{
                                        display:'flex',
                                        gap:1.5,
                                        alignItems:'center',
                                    }}
                                >

                                    <Text italic>
                                        {t("optional")}
                                    </Text>
                                    <Box
                                        sx={{
                                            height:24,
                                            width:24,
                                            borderRadius:3,
                                            display:"flex",
                                            alignItems:'center',
                                            justifyContent:"center",
                                            background:theme.palette.mode === "dark" ? colors.grey[600] : colors.grey[100],
                                            color: colors.txt["secondary"],
                                        }}
                                    >
                                        <KeyboardArrowDownIcon/>

                                    </Box>
                                </Box>

                            </ButtonBase>
                        )}
                    </ShDropdownQuery>

                    <ShDropdownQuery
                        onChange={(selected,object) => {
                            setOptionMap(optionMap => ({
                                ...optionMap,
                                reachtype: selected !== null ? object : {
                                    id:-1,
                                    name: t("all")
                                }
                            }))
                        }}
                        valueKey={"id"}
                        dataKey={"data.reachtypes"}
                        shComponent={<CountShQueryDropdown/>}
                        selected={optionMap.reachtype.id}
                        config={{
                            type:"reachtype",
                            body: getFilterIds(optionMap),
                        }}
                        content={useGetOptionsQuery}
                        closeOnSelection
                        lazyLoad
                    >
                        {({anchorEl,onClick}) => (
                            <ButtonBase

                                disabled={optionMap.warehouse.id === -1}
                                onClick={(e) => {
                                    if(optionMap.warehouse.id > -1 && optionMap.user.id > -1 ) {
                                        onClick(e);
                                    }
                                }}
                                sx={{
                                    mt:1.5,
                                    height:32,
                                    borderRadius:5,
                                    background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[0],
                                    boxShadow:`0px 2px 4px ${colors.grey[200]}`,
                                    border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                                    display:"flex",
                                    alignItems:'center',
                                    px:0.5,
                                    opacity: optionMap.warehouse.id > -1 && optionMap.user.id > -1  ? 1 : 0.35
                                }}
                            >

                                <Box
                                    sx={{
                                        height:24,
                                        lineHeight:"24px",
                                        background:theme.palette.mode === "dark" ? colors.grey[600] : colors.grey[100],
                                        borderRadius:3,
                                        width:110,
                                        textAlign:"center",
                                        fontSize:14,
                                        color:theme.palette.mode === "dark" ? colors.txt["softened"] : colors.txt["primary"],
                                    }}
                                >
                                    {t("reachtype")}

                                </Box>
                                <Box
                                    sx={{
                                        flex:1,
                                        ml:1.5,
                                        textAlign:"left",
                                    }}
                                >
                                    <Text semibold >
                                        {optionMap.reachtype.name}
                                    </Text>
                                </Box>
                                <Box
                                    sx={{
                                        display:'flex',
                                        gap:1.5,
                                        alignItems:'center',
                                    }}
                                >
                                    <Text italic>
                                        {t("optional")}
                                    </Text>
                                    <Box
                                        sx={{
                                            height:24,
                                            width:24,
                                            borderRadius:3,
                                            display:"flex",
                                            alignItems:'center',
                                            justifyContent:"center",
                                            background:theme.palette.mode === "dark" ? colors.grey[600] : colors.grey[100],
                                            color: colors.txt["secondary"],
                                        }}
                                    >
                                        <KeyboardArrowDownIcon/>

                                    </Box>
                                </Box>

                            </ButtonBase>
                        )}
                    </ShDropdownQuery>

                </Box>
            </Box>
            <Box
                sx={{
                    position:'sticky',
                    top:0,
                    width:2,
                    mx:"12px",
                    flexShrink: 0,
                    background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[100]
                }}
            />
            <Box
                sx={{
                    position:"sticky",
                    top:0,
                    pr:3,
                    pt:3,
                    pl:1.5,
                    pb:3,
                    flex:1,
                    alignSelf:"flex-start",
                    maxHeight:"100%",
                    overflow:"auto",
                }}
            >
                <Subheading>{t("preliminary_batch_info_title")}</Subheading>
                <Box
                    sx={{
                        mt:2,
                        background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[50],
                        border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[200]}`,
                        borderRadius:4,
                        display:"flex",
                        opacity:optionMap.warehouse.id > -1 && optionMap.user.id > -1  ? 1 : 0.35
                    }}
                >
                    <Box
                        sx={{
                            py:2,
                            px:2,
                            flex:1,
                        }}
                    >
                        <Text>{t("order_count_filtered")}</Text>
                        {!isLoading && !isFetching ? 
                        <Heading sx={{mt:0.5}}>{filterCount?.orderCount}</Heading>
                        : 
                            <ShTextSkeleton sx={{mt:0.5,height:24,borderRadius:2,}}/>
                        }
                    </Box>

                    <Box
                        sx={{
                            my:0.5,
                            mr:0.5,
                            flex:1,
                            // background:colors.primary[100],
                            background:amountError ? colors.red[100] : "#EBF9FE",
                            borderRadius:3,
                            border: `1px solid ${amountError ? colors.red[400] : "#7AD7FB"}`,
                            py:2,
                            px:2,
                            position:'relative',
                        }}
                    >
                        
                        <Text
                            sx={{
                                color:tokens('light').txt["primary"],
                                zIndex:2,
                            }}
                        >
                            {t("amount_in_batch")}
                        </Text>
                        <InputBase 
                            disabled={isLoading || isFetching || optionMap.warehouse.id === -1}
                            onChange={(e) => {
                                const input = e.target.value;
                                if (/^\d*$/.test(input)) {
                                    if (input === '' || /^[1-9]\d*$/.test(input)) {
                                        if(filterCount?.orderCount) {
                                            if(input <= filterCount?.orderCount){
                                                setOrderAmount(input);
                                            } else {
                                                toast.warning(t("cant_exceed_max"), {
                                                    position: toast.POSITION.TOP_RIGHT,
                                                    autoClose:5000,
                                                });
                                            }
                                        }
                                    }
                                }
                            }}
                            value={orderAmount}
                            sx={{
                                color:colors.txt["primary"],
                                px:1,
                                mt:0.5,
                                width:1,
                                height:24,
                                lineHeight:"24px",
                                borderRadius:3,
                                background:theme.palette.mode === "dark" ? tokens("light").grey[0] : colors.grey[0],
                                border:`1px solid ${colors.grey[200]}`
                            }}
                        />

                    </Box>

                </Box>

                <Box
                    sx={{
                        mt:1.5,
                        p:2,
                        display:"flex",
                        flexDirection:"column",
                        background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                        border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                        boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                        borderRadius:4,
                    }}
                >
                    <Text>
                        {t('products')}
                    </Text>

                    {optionMap.product.length === 0 ?
                        <Text bold>
                            {t("all")}
                        </Text>
                    :
                        <Box>
                            <Text bold>
                                {optionMap.product.length}&nbsp;
                            </Text>

                            <Text light>
                                {t("selected")}
                            </Text>
                        </Box>
                    }

                        {optionMap.product.length > 0 && (
                        <Box
                            sx={{
                                mt:2,
                                width:1,
                                display:"flex",
                                flexDirection:"column",
                                gap:1,
                            }}
                        >
                            {optionMap.product.map((item) => (
                                <Box
                                    key={"prod"+item.id}
                                    sx={{
                                        py:0.5,
                                        minHeight:24,
                                        background:theme.palette.mode === "dark" ? colors.grey[500] : colors.grey[100],
                                        width:1,
                                        borderRadius:3,
                                        px:2,
                                        display:"flex",
                                        alignItems:'center',
                                        justifyContent:'space-between'
                                        // overflow:"hidden",
                                        // textOverflow:"ellipsis"
                                    }}
                                >
                                    <Text>
                                        {item.combined}
                                    </Text>

                                    <ButtonBase
                                        onClick={() => {
                                            setOptionMap(prev => ({
                                                ...prev,
                                                product: prev.product.filter(
                                                    zone => zone.id !== item.id
                                                ),
                                            }));
                                        }}
                                        sx={{
                                            borderRadius:2,
                                            mr:"-12px",
                                            height:24,
                                            width:24,
                                            alignSelf:"flex-start",
                                            background:colors.red[100],
                                            color:colors.red[400],
                                            border: `1px solid ${colors.red[400]}`
                                        }}
                                    >
                                        <CloseIcon fontSize="small"/>
                                    </ButtonBase>
                                </Box>

                            ))}
                            
                        </Box>

                    )}
                </Box>
            </Box>
        </Box>
    )
}

export const StartCreatebatchFooter = ({handleSave, createJobLoading,handleClose}) => {
    const {t} = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    return (
        <>
            <Shbutton isCancel={true} className={"always-visible"} onClick={handleClose} color="primary" variant="text" startIcon={<ArrowRightAltIcon/>}>{t("cancel")}</Shbutton>
            <ButtonGroup version={2}>
                <Shbutton className={"group-btn"} 
                color={theme.palette.mode === "dark" ? "blue" : "primary"}
                variant="contained" 
                isLoading={createJobLoading}
                onClick={() => handleSave()}
                >{t("start")}</Shbutton>
            </ButtonGroup>
        </>
    )
}